import Vue from 'vue';
import RestX from 'highered-utils/restx';

// Plugins and template functions
import Token from '~/api/Token';

import createPersistedState from 'vuex-persistedstate';

// Module imports
import posting from './modules/postingModule';
import company from './modules/companyModule';
import profile from './modules/profileModule';
import school from './modules/schoolModule';
import degree from './modules/degreeModule';
import token from './modules/tokenModule';
import companyFollow from './modules/companyFollowModule';
import user from './modules/userModule';
import university from './modules/universityModule';
import complete from './modules/suggestionModule';
import event from './modules/eventModule';
import candidate from './modules/candidateModule';
import organization from './modules/organizationModule';
import identity from './modules/identityModule';
import resources from './modules/resourceModule';
import calendar from './modules/calendarModule';
import vfair from './modules/vfairModule';
import vfairs from './modules/vfairsModule';
import vfairuser from './modules/vfairuserModule';
import communication from './modules/communicationModule';

import autocomplete from './modules/autocompleteModule';

// Custom Module imports
import logInModule from './customModules/logInModule';
import unsavedChanges from './customModules/unsavedChanges';
import dialogModal from './customModules/dialogModal';
import messageModule from './customModules/messageModule';
import webinarMessageModule from './customModules/webinarMessageModule';
import scrollState from './customModules/scrollState';
import floatingActionButton from './customModules/floatingActionButton';
import uniBadgeModule from './customModules/uniBadgeModule';
import localeModule from './customModules/localeModule';
import fakeLoad from './customModules/fakeLoad';
import favoriteModule from './customModules/favoriteModule';
import vFairModule from './customModules/vFairModule';
import assessmentModule from './customModules/assessmentModule';
import videoCallModule from './customModules/videoCallModule';
import profileModule from './customModules/profileModule';
import widgetModule from './customModules/widgetModule';
import miscModule from './customModules/miscModule';

// Middleware imports
import { getAccessByRefresh, shouldRefreshToken } from './middlewares/refreshToken';

Vue.use(RestX);

RestX.registerTemplateFunctions({
    shouldRefreshToken: shouldRefreshToken,
    getAccessByRefresh: getAccessByRefresh,
    setRefreshToken: refreshToken => Token.setRefresh(refreshToken),
    setToken: token => Token.setAccess(token),
    getAuthToken: () => Token.getAccess(),
    isAuthenticated: () => Token.isAuthenticated(),
});

RestX.registerPlugins([
    createPersistedState({
        // Alf: Disabled user path for now. Was able to get stuck on loading true.
        paths: ['localeModule.locale', 'user' /* 'company' */], // Currently there is no support for timeouts on localstored data...
        filter: mutation =>
            mutation.type === 'localeModule/setLocaleItem' ||
            mutation.type.startsWith('user') ||
            mutation.type.startsWith('company'),
    }),
]);

RestX.createCustomModule('logInModule', logInModule);
RestX.createCustomModule('unsavedChanges', unsavedChanges);
RestX.createCustomModule('dialogModal', dialogModal);
RestX.createCustomModule('messageModule', messageModule);
RestX.createCustomModule('webinarMessageModule', webinarMessageModule);
RestX.createCustomModule('scrollState', scrollState);
RestX.createCustomModule('floatingActionButton', floatingActionButton);
RestX.createCustomModule('uniBadgeModule', uniBadgeModule);
RestX.createCustomModule('localeModule', localeModule);
RestX.createCustomModule('fakeLoad', fakeLoad);
RestX.createCustomModule('favoriteModule', favoriteModule);
RestX.createCustomModule('vfairModule', vFairModule);
RestX.createCustomModule('assessmentModule', assessmentModule);
RestX.createCustomModule('videoCallModule', videoCallModule);
RestX.createCustomModule('profileModule', profileModule);
RestX.createCustomModule('widgetModule', widgetModule);
RestX.createCustomModule('misc', miscModule);

const store = RestX.createStore(
    {
        posting,
        company,
        user,
        candidate,
        profile,
        school,
        degree,
        token,
        companyFollow,
        complete,
        event,
        university,
        organization,
        identity,
        autocomplete,
        resources,
        calendar,
        vfair,
        vfairuser,
        communication,
        vfairs,
    }
    //, console
);

export default store;
